import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import {  Edit, Trash2 } from "react-feather";

import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ExpenseCategoryModal from "../../core/modals/FinanceAccount/expenseCategoryModal";

import axios from "axios";

const ExpenseCategory = () => {

  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedExpenseCategoryId, setSelectedExpenseCategoryId] = useState(null);
  // const toggleFilterVisibility = () => {
  //   setIsFilterVisible((prevVisibility) => !prevVisibility);
  // };

  const [expenseCategories, setExpenseCategory] = useState([]);

  const [shouldReloadData, setShouldReloadData] = useState(false);
 

 

  useEffect(() => {
    fetchExpenseCategory();
    
  }, [shouldReloadData]);

  const fetchExpenseCategory = async () => {
    try {
      const response = await axios.get(`/expenseCategories`);
      console.log("Fetched data:", response.data);
      setExpenseCategory(response.data.data.expenseCategory);
      
    } catch (error) {
      console.error("Error fetching expenseCategory:", error);
    }
  };
  

  const handleReloadData = () => {
    setShouldReloadData(!shouldReloadData);
  };

  


  const columns = [
    {
      render: () => (
        <label className="checkboxs">
          <input type="checkbox" />
          <span className="checkmarks" />
        </label>
      ),
      width: 50,
    },

    {
      title: "Category Name",
      dataIndex: "CategoryName",
      width: 200,
      // sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    },

    {
      title: "Description",
      dataIndex: "Description",
      width: 250,
      // sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      width:150,
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);

  
  const showConfirmationAlert = (expenseCategoryId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteExpenseCategory(expenseCategoryId);
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const deleteExpenseCategory = async (expenseCategoryId) => {
    try {
       await axios.delete(`/expenseCategories/${expenseCategoryId}`);
       handleReloadData();
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "Cannot Delete this expenses category",
            icon: "error",
          })
    }
  };
  
  const handleLinkClick = async (expenseCategoryId) => {
    setSelectedExpenseCategoryId(expenseCategoryId);
  };

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredExpenceCategories = expenseCategories?.filter(expenseCategory => {
    const searchLower = searchQuery.toLowerCase();
    return (
      expenseCategory.expenseCategoryName.toLowerCase().includes(searchLower)
    );
   });
  return (
    <div className="page-wrapper">
      <div className="content">
      
          <Breadcrumbs
          maintitle="Expenses Category List "
          subtitle="Manage Your Expenses Category"
          addButton="Add New Expenses Category"
        />
      

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search" 
                    placeholder="Search Category Name"
                    className="form-control form-control-sm formsearch" 
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              {/* <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div> */}
              
            </div>
            {/* /Filter
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          
                          <Zap className="info-img" />
                          <Select
                            options={Categories}
                            placeholder="Choose Category"
                          />
                        </div>
                      </div>
                      <div className="col-lg-9 col-sm-6 col-12">
                        <div className="input-blocks">
                          <Link className="btn btn-filters ms-auto">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />{" "}
                            Search{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
            </div> */}
            {/* /Filter */}
            <div className="table-responsive">
            <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={filteredExpenceCategories?.map((expenseCategory) => ({
                    key: expenseCategory._id,
                    CategoryName: expenseCategory.expenseCategoryName,
                    Description: expenseCategory.expenseCategoryDescription,
                    action: (
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <div className="input-block add-lists"></div>
                          
                               <Link
                               className="me-2 p-2"
                               to="#"
                               data-bs-toggle="modal"
                               data-bs-target="#edit-units"
                               onClick={() => handleLinkClick(expenseCategory._id)}
                               >
                               <Edit className="feather-edit" />
                              </Link>
                          
                          
                              <Link
                              className="confirm-text p-2"
                              to="#"
                              onClick={() => showConfirmationAlert(expenseCategory._id)}
                              >
                              <Trash2 className="feather-trash-2" />
                              </Link>
                          
                        </div>
                      </td>
                    ),
                  }))}
                  pagination={false}
                />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>

      <ExpenseCategoryModal onExpenseCategoryAdded={handleReloadData} expenseCategoryId={selectedExpenseCategoryId}/>
    </div>
  );
};

export default ExpenseCategory;
